// extracted by mini-css-extract-plugin
module.exports = {"map":"SummaryCard_map__3x0r9","wrapper":"SummaryCard_wrapper__1kz2v","title":"SummaryCard_title__2XdQw","value":"SummaryCard_value__1l0q5","unit":"SummaryCard_unit__kuALS"};